import styled from "@emotion/styled"
import type { RoomBranding } from "../../../../recoil/atoms/room/types"
import { isRGBAcolor, removeOpacity } from "../../../../util"
import { StylesWithSelectors } from "../../../../types"

export interface StylesProps {
  roomStyles?: RoomBranding
  customStyles?: StylesWithSelectors
  isLandscape?: boolean
  isSmallScreen?: boolean
  isLargeScreen?: boolean
  isMobile?: boolean
  isTablet?: boolean
  widthImagesContainer?: number
  buttonsContainerHeight?: number
  isWatchParty?: boolean
}

export const ModalProductContainer = styled.div<StylesProps>`
  display: flex;
  background: ${({ roomStyles }) =>
    roomStyles.badgeBackgroundColor
      ? isRGBAcolor(roomStyles.badgeBackgroundColor)
        ? removeOpacity(roomStyles.badgeBackgroundColor)
        : roomStyles.badgeBackgroundColor
      : "white"};
  border-width: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "0px" : "1px"};
  border-style: solid;
  border-color: ${({ roomStyles }) => roomStyles.badgeBorderColor ?? "#CBD5E0"};
  padding: 0.5rem;
  border-top-right-radius: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "0px" : "0.5rem"};
  border-bottom-right-radius: ${({ isMobile, isTablet, isLandscape }) =>
    isLandscape
      ? "1.5rem 0.5rem 1.5rem 0.5rem"
      : isMobile || isTablet
      ? "0px"
      : "0.5rem"};
`

export const ImageProductContainer = styled.div<StylesProps>`
  display: flex;
  margin-right: 0.3rem;
  flex-direction: ${({ isSmallScreen }) => (isSmallScreen ? "column" : "row")};
  width: ${({ isLandscape, isLargeScreen, isMobile }) =>
    isLandscape || isLargeScreen ? "50%" : isMobile ? "40%" : "50%"};
  min-width: ${({ isLargeScreen }) => isLargeScreen && "120px"};
  max-width: ${({ isSmallScreen }) => !isSmallScreen && "60%"};
  .rsis-container ~ button {
    background: rgba(0, 0, 0, 0.3) !important;
    border-radius: 50% !important;
    padding: 5px !important;
  }
  img[alt="slide to right"] {
    margin-left: 1px;
  }

  img[alt="slide to left"] {
    margin-left: -1px;
  }
`

export const SmallContainerProductPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SelectContainer = styled.div<StylesProps>`
  display: flex;
  height: ${({ buttonsContainerHeight }) =>
    `calc(100% - ${buttonsContainerHeight + 10}px)`};
  width: ${({
    isLandscape,
    isLargeScreen,
    isSmallScreen,
    isMobile,
    widthImagesContainer
  }) =>
    isLandscape
      ? "50%"
      : isLargeScreen
      ? `calc(100% - ${widthImagesContainer}px)`
      : isMobile
      ? "60%"
      : isSmallScreen
      ? "50%"
      : "50%"};
`

export const ConfirmButtonsContainer = styled.div<StylesProps>`
  display: flex;
  width: 100%;
  margin-top: auto;
  position: absolute;
  bottom: ${({ isLandscape }) => (isLandscape ? "1.4rem" : "0.5rem")};
  right: ${({ isLandscape, isMobile, isTablet, isWatchParty }) =>
    isMobile && !isTablet && !isLandscape
      ? "1rem"
      : isWatchParty && isLandscape
      ? "0.5rem"
      : "0.5rem"};
`
